const countriesList = [{
  name: 'Australia',
  dial_code: '+61',
  code: 'AU',
  order: 13,
  img: require('@/assets/countriesPic/au.svg')
}, {
  name: 'Aland Islands',
  dial_code: '+358',
  code: 'AX',
  order: 1,
  img: require('@/assets/countriesPic/ax.svg')
}, {
  name: 'Albania',
  dial_code: '+355',
  code: 'AL',
  order: 2,
  img: require('@/assets/countriesPic/al.svg')
}, {
  name: 'Algeria',
  dial_code: '+213',
  code: 'DZ',
  order: 3,
  img: require('@/assets/countriesPic/dz.svg')
}, {
  name: 'American Samoa',
  dial_code: '+1684',
  code: 'AS',
  order: 4,
  img: require('@/assets/countriesPic/as.svg')
}, {
  name: 'Andorra',
  dial_code: '+376',
  code: 'AD',
  order: 5,
  img: require('@/assets/countriesPic/ad.svg')
}, {
  name: 'Angola',
  dial_code: '+244',
  code: 'AO',
  order: 6,
  img: require('@/assets/countriesPic/ao.svg')
}, {
  name: 'Anguilla',
  dial_code: '+1264',
  code: 'AI',
  order: 7,
  img: require('@/assets/countriesPic/ai.svg')
}, {
  name: 'Antarctica',
  dial_code: '+672',
  code: 'AQ',
  order: 8,
  img: require('@/assets/countriesPic/aq.svg')
}, {
  name: 'Antigua and Barbuda',
  dial_code: '+1268',
  code: 'AG',
  order: 9,
  img: require('@/assets/countriesPic/ag.svg')
}, {
  name: 'Argentina',
  dial_code: '+54',
  code: 'AR',
  order: 10,
  img: require('@/assets/countriesPic/ar.svg')
}, {
  name: 'Armenia',
  dial_code: '+374',
  code: 'AM',
  order: 11,
  img: require('@/assets/countriesPic/am.svg')
}, {
  name: 'Aruba',
  dial_code: '+297',
  code: 'AW',
  order: 12,
  img: require('@/assets/countriesPic/aw.svg')
}, {
  name: 'Afghanistan',
  dial_code: '+93',
  code: 'AF',
  order: 0,
  img: require('@/assets/countriesPic/af.svg')
}, {
  name: 'Austria',
  dial_code: '+43',
  code: 'AT',
  order: 14,
  img: require('@/assets/countriesPic/at.svg')
}, {
  name: 'Azerbaijan',
  dial_code: '+994',
  code: 'AZ',
  order: 15,
  img: require('@/assets/countriesPic/az.svg')
}, {
  name: 'Bahamas',
  dial_code: '+1242',
  code: 'BS',
  order: 16,
  img: require('@/assets/countriesPic/bs.svg')
}, {
  name: 'Bahrain',
  dial_code: '+973',
  code: 'BH',
  order: 17,
  img: require('@/assets/countriesPic/bh.svg')
}, {
  name: 'Bangladesh',
  dial_code: '+880',
  code: 'BD',
  order: 18,
  img: require('@/assets/countriesPic/bd.svg')
}, {
  name: 'Barbados',
  dial_code: '+1246',
  code: 'BB',
  order: 19,
  img: require('@/assets/countriesPic/bb.svg')
}, {
  name: 'Belarus',
  dial_code: '+375',
  code: 'BY',
  order: 20,
  img: require('@/assets/countriesPic/by.svg')
}, {
  name: 'Belgium',
  dial_code: '+32',
  code: 'BE',
  order: 21,
  img: require('@/assets/countriesPic/be.svg')
}, {
  name: 'Belize',
  dial_code: '+501',
  code: 'BZ',
  order: 22,
  img: require('@/assets/countriesPic/bz.svg')
}, {
  name: 'Benin',
  dial_code: '+229',
  code: 'BJ',
  order: 23,
  img: require('@/assets/countriesPic/bj.svg')
}, {
  name: 'Bermuda',
  dial_code: '+1441',
  code: 'BM',
  order: 24,
  img: require('@/assets/countriesPic/bm.svg')
}, {
  name: 'Bhutan',
  dial_code: '+975',
  code: 'BT',
  order: 25,
  img: require('@/assets/countriesPic/bt.svg')
}, {
  name: 'Bolivia, Plurinational State of',
  dial_code: '+591',
  code: 'BO',
  order: 26,
  img: require('@/assets/countriesPic/bo.svg')
}, {
  name: 'Bosnia and Herzegovina',
  dial_code: '+387',
  code: 'BA',
  order: 27,
  img: require('@/assets/countriesPic/ba.svg')
}, {
  name: 'Botswana',
  dial_code: '+267',
  code: 'BW',
  order: 28,
  img: require('@/assets/countriesPic/bw.svg')
}, {
  name: 'Brazil',
  dial_code: '+55',
  code: 'BR',
  order: 29,
  img: require('@/assets/countriesPic/br.svg')
}, {
  name: 'British Indian Ocean Territory',
  dial_code: '+246',
  code: 'IO',
  order: 30,
  img: require('@/assets/countriesPic/io.svg')
}, {
  name: 'Brunei Darussalam',
  dial_code: '+673',
  code: 'BN',
  order: 31,
  img: require('@/assets/countriesPic/bn.svg')
}, {
  name: 'Bulgaria',
  dial_code: '+359',
  code: 'BG',
  order: 32,
  img: require('@/assets/countriesPic/bg.svg')
}, {
  name: 'Burkina Faso',
  dial_code: '+226',
  code: 'BF',
  order: 33,
  img: require('@/assets/countriesPic/bf.svg')
}, {
  name: 'Burundi',
  dial_code: '+257',
  code: 'BI',
  order: 34,
  img: require('@/assets/countriesPic/bi.svg')
}, {
  name: 'Cambodia',
  dial_code: '+855',
  code: 'KH',
  order: 35,
  img: require('@/assets/countriesPic/kh.svg')
}, {
  name: 'Cameroon',
  dial_code: '+237',
  code: 'CM',
  order: 36,
  img: require('@/assets/countriesPic/cm.svg')
}, {
  name: 'Canada',
  dial_code: '+1',
  code: 'CA',
  order: 37,
  img: require('@/assets/countriesPic/ca.svg')
}, {
  name: 'Cape Verde',
  dial_code: '+238',
  code: 'CV',
  order: 38,
  img: require('@/assets/countriesPic/cv.svg')
}, {
  name: 'Cayman Islands',
  dial_code: '+ 345',
  code: 'KY',
  order: 39,
  img: require('@/assets/countriesPic/ky.svg')
}, {
  name: 'Central African Republic',
  dial_code: '+236',
  code: 'CF',
  order: 40,
  img: require('@/assets/countriesPic/cf.svg')
}, {
  name: 'Chad',
  dial_code: '+235',
  code: 'TD',
  order: 41,
  img: require('@/assets/countriesPic/td.svg')
}, {
  name: 'Chile',
  dial_code: '+56',
  code: 'CL',
  order: 42,
  img: require('@/assets/countriesPic/cl.svg')
}, {
  name: 'China',
  dial_code: '+86',
  code: 'CN',
  order: 43,
  img: require('@/assets/countriesPic/cn.svg')
}, {
  name: 'Christmas Island',
  dial_code: '+61',
  code: 'CX',
  order: 44,
  img: require('@/assets/countriesPic/cx.svg')
}, {
  name: 'Cocos (Keeling) Islands',
  dial_code: '+61',
  code: 'CC',
  order: 45,
  img: require('@/assets/countriesPic/cc.svg')
}, {
  name: 'Colombia',
  dial_code: '+57',
  code: 'CO',
  order: 46,
  img: require('@/assets/countriesPic/co.svg')
}, {
  name: 'Comoros',
  dial_code: '+269',
  code: 'KM',
  order: 47,
  img: require('@/assets/countriesPic/km.svg')
}, {
  name: 'Congo',
  dial_code: '+242',
  code: 'CG',
  order: 48,
  img: require('@/assets/countriesPic/cg.svg')
}, {
  name: 'Congo, The Democratic Republic of the Congo',
  dial_code: '+243',
  code: 'CD',
  order: 49,
  img: require('@/assets/countriesPic/cd.svg')
}, {
  name: 'Cook Islands',
  dial_code: '+682',
  code: 'CK',
  order: 50,
  img: require('@/assets/countriesPic/ck.svg')
}, {
  name: 'Costa Rica',
  dial_code: '+506',
  code: 'CR',
  order: 51,
  img: require('@/assets/countriesPic/cr.svg')
}, {
  name: 'Cote d\'Ivoire',
  dial_code: '+225',
  code: 'CI',
  order: 52,
  img: require('@/assets/countriesPic/ci.svg')
}, {
  name: 'Croatia',
  dial_code: '+385',
  code: 'HR',
  order: 53,
  img: require('@/assets/countriesPic/hr.svg')
}, {
  name: 'Cuba',
  dial_code: '+53',
  code: 'CU',
  order: 54,
  img: require('@/assets/countriesPic/cu.svg')
}, {
  name: 'Cyprus',
  dial_code: '+357',
  code: 'CY',
  order: 55,
  img: require('@/assets/countriesPic/cy.svg')
}, {
  name: 'Czech Republic',
  dial_code: '+420',
  code: 'CZ',
  order: 56,
  img: require('@/assets/countriesPic/cz.svg')
}, {
  name: 'Denmark',
  dial_code: '+45',
  code: 'DK',
  order: 57,
  img: require('@/assets/countriesPic/dk.svg')
}, {
  name: 'Djibouti',
  dial_code: '+253',
  code: 'DJ',
  order: 58,
  img: require('@/assets/countriesPic/dj.svg')
}, {
  name: 'Dominica',
  dial_code: '+1767',
  code: 'DM',
  order: 59,
  img: require('@/assets/countriesPic/dm.svg')
}, {
  name: 'Dominican Republic',
  dial_code: '+1849',
  code: 'DO',
  order: 60,
  img: require('@/assets/countriesPic/do.svg')
}, {
  name: 'Ecuador',
  dial_code: '+593',
  code: 'EC',
  order: 61,
  img: require('@/assets/countriesPic/ec.svg')
}, {
  name: 'Egypt',
  dial_code: '+20',
  code: 'EG',
  order: 62,
  img: require('@/assets/countriesPic/eg.svg')
}, {
  name: 'El Salvador',
  dial_code: '+503',
  code: 'SV',
  order: 63,
  img: require('@/assets/countriesPic/sv.svg')
}, {
  name: 'Equatorial Guinea',
  dial_code: '+240',
  code: 'GQ',
  order: 64,
  img: require('@/assets/countriesPic/gq.svg')
}, {
  name: 'Eritrea',
  dial_code: '+291',
  code: 'ER',
  order: 65,
  img: require('@/assets/countriesPic/er.svg')
}, {
  name: 'Estonia',
  dial_code: '+372',
  code: 'EE',
  order: 66,
  img: require('@/assets/countriesPic/ee.svg')
}, {
  name: 'Ethiopia',
  dial_code: '+251',
  code: 'ET',
  order: 67,
  img: require('@/assets/countriesPic/et.svg')
}, {
  name: 'Falkland Islands (Malvinas)',
  dial_code: '+500',
  code: 'FK',
  order: 68,
  img: require('@/assets/countriesPic/fk.svg')
}, {
  name: 'Faroe Islands',
  dial_code: '+298',
  code: 'FO',
  order: 69,
  img: require('@/assets/countriesPic/fo.svg')
}, {
  name: 'Fiji',
  dial_code: '+679',
  code: 'FJ',
  order: 70,
  img: require('@/assets/countriesPic/fj.svg')
}, {
  name: 'Finland',
  dial_code: '+358',
  code: 'FI',
  order: 71,
  img: require('@/assets/countriesPic/fi.svg')
}, {
  name: 'France',
  dial_code: '+33',
  code: 'FR',
  order: 72,
  img: require('@/assets/countriesPic/fr.svg')
}, {
  name: 'French Guiana',
  dial_code: '+594',
  code: 'GF',
  order: 73,
  img: require('@/assets/countriesPic/gf.svg')
}, {
  name: 'French Polynesia',
  dial_code: '+689',
  code: 'PF',
  order: 74,
  img: require('@/assets/countriesPic/pf.svg')
}, {
  name: 'Gabon',
  dial_code: '+241',
  code: 'GA',
  order: 75,
  img: require('@/assets/countriesPic/ga.svg')
}, {
  name: 'Gambia',
  dial_code: '+220',
  code: 'GM',
  order: 76,
  img: require('@/assets/countriesPic/gm.svg')
}, {
  name: 'Georgia',
  dial_code: '+995',
  code: 'GE',
  order: 77,
  img: require('@/assets/countriesPic/ge.svg')
}, {
  name: 'Germany',
  dial_code: '+49',
  code: 'DE',
  order: 78,
  img: require('@/assets/countriesPic/de.svg')
}, {
  name: 'Ghana',
  dial_code: '+233',
  code: 'GH',
  order: 79,
  img: require('@/assets/countriesPic/gh.svg')
}, {
  name: 'Gibraltar',
  dial_code: '+350',
  code: 'GI',
  order: 80,
  img: require('@/assets/countriesPic/gi.svg')
}, {
  name: 'Greece',
  dial_code: '+30',
  code: 'GR',
  order: 81,
  img: require('@/assets/countriesPic/gr.svg')
}, {
  name: 'Greenland',
  dial_code: '+299',
  code: 'GL',
  order: 82,
  img: require('@/assets/countriesPic/gl.svg')
}, {
  name: 'Grenada',
  dial_code: '+1473',
  code: 'GD',
  order: 83,
  img: require('@/assets/countriesPic/gd.svg')
}, {
  name: 'Guadeloupe',
  dial_code: '+590',
  code: 'GP',
  order: 84,
  img: require('@/assets/countriesPic/gp.svg')
}, {
  name: 'Guam',
  dial_code: '+1671',
  code: 'GU',
  order: 85,
  img: require('@/assets/countriesPic/gu.svg')
}, {
  name: 'Guatemala',
  dial_code: '+502',
  code: 'GT',
  order: 86,
  img: require('@/assets/countriesPic/gt.svg')
}, {
  name: 'Guernsey',
  dial_code: '+44',
  code: 'GG',
  order: 87,
  img: require('@/assets/countriesPic/gg.svg')
}, {
  name: 'Guinea',
  dial_code: '+224',
  code: 'GN',
  order: 88,
  img: require('@/assets/countriesPic/gn.svg')
}, {
  name: 'Guinea-Bissau',
  dial_code: '+245',
  code: 'GW',
  order: 89,
  img: require('@/assets/countriesPic/gw.svg')
}, {
  name: 'Guyana',
  dial_code: '+595',
  code: 'GY',
  order: 90,
  img: require('@/assets/countriesPic/gy.svg')
}, {
  name: 'Haiti',
  dial_code: '+509',
  code: 'HT',
  order: 91,
  img: require('@/assets/countriesPic/ht.svg')
}, {
  name: 'Holy See (Vatican City State)',
  dial_code: '+379',
  code: 'VA',
  order: 92,
  img: require('@/assets/countriesPic/va.svg')
}, {
  name: 'Honduras',
  dial_code: '+504',
  code: 'HN',
  order: 93,
  img: require('@/assets/countriesPic/hn.svg')
}, {
  name: 'Hong Kong',
  dial_code: '+852',
  code: 'HK',
  order: 94,
  img: require('@/assets/countriesPic/hk.svg')
}, {
  name: 'Hungary',
  dial_code: '+36',
  code: 'HU',
  order: 95,
  img: require('@/assets/countriesPic/hu.svg')
}, {
  name: 'Iceland',
  dial_code: '+354',
  code: 'IS',
  order: 96,
  img: require('@/assets/countriesPic/is.svg')
}, {
  name: 'India',
  dial_code: '+91',
  code: 'IN',
  order: 97,
  img: require('@/assets/countriesPic/in.svg')
}, {
  name: 'Indonesia',
  dial_code: '+62',
  code: 'ID',
  order: 98,
  img: require('@/assets/countriesPic/id.svg')
}, {
  name: 'Iran, Islamic Republic',
  dial_code: '+98',
  code: 'IR',
  order: 99,
  img: require('@/assets/countriesPic/ir.svg')
}, {
  name: 'Iraq',
  dial_code: '+964',
  code: 'IQ',
  order: 100,
  img: require('@/assets/countriesPic/iq.svg')
}, {
  name: 'Ireland',
  dial_code: '+353',
  code: 'IE',
  order: 101,
  img: require('@/assets/countriesPic/ie.svg')
}, {
  name: 'Isle of Man',
  dial_code: '+44',
  code: 'IM',
  order: 102,
  img: require('@/assets/countriesPic/im.svg')
}, {
  name: 'Israel',
  dial_code: '+972',
  code: 'IL',
  order: 103,
  img: require('@/assets/countriesPic/il.svg')
}, {
  name: 'Italy',
  dial_code: '+39',
  code: 'IT',
  order: 104,
  img: require('@/assets/countriesPic/it.svg')
}, {
  name: 'Jamaica',
  dial_code: '+1876',
  code: 'JM',
  order: 105,
  img: require('@/assets/countriesPic/jm.svg')
}, {
  name: 'Japan',
  dial_code: '+81',
  code: 'JP',
  order: 106,
  img: require('@/assets/countriesPic/jp.svg')
}, {
  name: 'Jersey',
  dial_code: '+44',
  code: 'JE',
  order: 107,
  img: require('@/assets/countriesPic/je.svg')
}, {
  name: 'Jordan',
  dial_code: '+962',
  code: 'JO',
  order: 108,
  img: require('@/assets/countriesPic/jo.svg')
}, {
  name: 'Kazakhstan',
  dial_code: '+7',
  code: 'KZ',
  order: 109,
  img: require('@/assets/countriesPic/kz.svg')
}, {
  name: 'Kenya',
  dial_code: '+254',
  code: 'KE',
  order: 110,
  img: require('@/assets/countriesPic/ke.svg')
}, {
  name: 'Kiribati',
  dial_code: '+686',
  code: 'KI',
  order: 111,
  img: require('@/assets/countriesPic/ki.svg')
}, {
  name: 'Korea, Republic of South Korea',
  dial_code: '+82',
  code: 'KR',
  order: 112,
  img: require('@/assets/countriesPic/kr.svg')
}, {
  name: 'Kuwait',
  dial_code: '+965',
  code: 'KW',
  order: 113,
  img: require('@/assets/countriesPic/kw.svg')
}, {
  name: 'Kyrgyzstan',
  dial_code: '+996',
  code: 'KG',
  order: 114,
  img: require('@/assets/countriesPic/kg.svg')
}, {
  name: 'Laos',
  dial_code: '+856',
  code: 'LA',
  order: 115,
  img: require('@/assets/countriesPic/la.svg')
}, {
  name: 'Latvia',
  dial_code: '+371',
  code: 'LV',
  order: 116,
  img: require('@/assets/countriesPic/lv.svg')
}, {
  name: 'Lebanon',
  dial_code: '+961',
  code: 'LB',
  order: 117,
  img: require('@/assets/countriesPic/lb.svg')
}, {
  name: 'Lesotho',
  dial_code: '+266',
  code: 'LS',
  order: 118,
  img: require('@/assets/countriesPic/ls.svg')
}, {
  name: 'Liberia',
  dial_code: '+231',
  code: 'LR',
  order: 119,
  img: require('@/assets/countriesPic/lr.svg')
}, {
  name: 'Libyan Arab Jamahiriya',
  dial_code: '+218',
  code: 'LY',
  order: 120,
  img: require('@/assets/countriesPic/ly.svg')
}, {
  name: 'Liechtenstein',
  dial_code: '+423',
  code: 'LI',
  order: 121,
  img: require('@/assets/countriesPic/li.svg')
}, {
  name: 'Lithuania',
  dial_code: '+370',
  code: 'LT',
  order: 122,
  img: require('@/assets/countriesPic/lt.svg')
}, {
  name: 'Luxembourg',
  dial_code: '+352',
  code: 'LU',
  order: 123,
  img: require('@/assets/countriesPic/lu.svg')
}, {
  name: 'Macao',
  dial_code: '+853',
  code: 'MO',
  order: 124,
  img: require('@/assets/countriesPic/mo.svg')
}, {
  name: 'Macedonia',
  dial_code: '+389',
  code: 'MK',
  order: 125,
  img: require('@/assets/countriesPic/mk.svg')
}, {
  name: 'Madagascar',
  dial_code: '+261',
  code: 'MG',
  order: 126,
  img: require('@/assets/countriesPic/mg.svg')
}, {
  name: 'Malawi',
  dial_code: '+265',
  code: 'MW',
  order: 127,
  img: require('@/assets/countriesPic/mw.svg')
}, {
  name: 'Malaysia',
  dial_code: '+60',
  code: 'MY',
  order: 128,
  img: require('@/assets/countriesPic/my.svg')
}, {
  name: 'Maldives',
  dial_code: '+960',
  code: 'MV',
  order: 129,
  img: require('@/assets/countriesPic/mv.svg')
}, {
  name: 'Mali',
  dial_code: '+223',
  code: 'ML',
  order: 130,
  img: require('@/assets/countriesPic/ml.svg')
}, {
  name: 'Malta',
  dial_code: '+356',
  code: 'MT',
  order: 131,
  img: require('@/assets/countriesPic/mt.svg')
}, {
  name: 'Marshall Islands',
  dial_code: '+692',
  code: 'MH',
  order: 132,
  img: require('@/assets/countriesPic/mh.svg')
}, {
  name: 'Martinique',
  dial_code: '+596',
  code: 'MQ',
  order: 133,
  img: require('@/assets/countriesPic/mq.svg')
}, {
  name: 'Mauritania',
  dial_code: '+222',
  code: 'MR',
  order: 134,
  img: require('@/assets/countriesPic/mr.svg')
}, {
  name: 'Mauritius',
  dial_code: '+230',
  code: 'MU',
  order: 135,
  img: require('@/assets/countriesPic/mu.svg')
}, {
  name: 'Mayotte',
  dial_code: '+262',
  code: 'YT',
  order: 136,
  img: require('@/assets/countriesPic/yt.svg')
}, {
  name: 'Mexico',
  dial_code: '+52',
  code: 'MX',
  order: 137,
  img: require('@/assets/countriesPic/mx.svg')
}, {
  name: 'Micronesia, Federated States of Micronesia',
  dial_code: '+691',
  code: 'FM',
  order: 138,
  img: require('@/assets/countriesPic/fm.svg')
}, {
  name: 'Moldova',
  dial_code: '+373',
  code: 'MD',
  order: 139,
  img: require('@/assets/countriesPic/md.svg')
}, {
  name: 'Monaco',
  dial_code: '+377',
  code: 'MC',
  order: 140,
  img: require('@/assets/countriesPic/mc.svg')
}, {
  name: 'Mongolia',
  dial_code: '+976',
  code: 'MN',
  order: 141,
  img: require('@/assets/countriesPic/mn.svg')
}, {
  name: 'Montenegro',
  dial_code: '+382',
  code: 'ME',
  order: 142,
  img: require('@/assets/countriesPic/me.svg')
}, {
  name: 'Montserrat',
  dial_code: '+1664',
  code: 'MS',
  order: 143,
  img: require('@/assets/countriesPic/ms.svg')
}, {
  name: 'Morocco',
  dial_code: '+212',
  code: 'MA',
  order: 144,
  img: require('@/assets/countriesPic/ma.svg')
}, {
  name: 'Mozambique',
  dial_code: '+258',
  code: 'MZ',
  order: 145,
  img: require('@/assets/countriesPic/mz.svg')
}, {
  name: 'Myanmar',
  dial_code: '+95',
  code: 'MM',
  order: 146,
  img: require('@/assets/countriesPic/mm.svg')
}, {
  name: 'Namibia',
  dial_code: '+264',
  code: 'NA',
  order: 147,
  img: require('@/assets/countriesPic/na.svg')
}, {
  name: 'Nauru',
  dial_code: '+674',
  code: 'NR',
  order: 148,
  img: require('@/assets/countriesPic/nr.svg')
}, {
  name: 'Nepal',
  dial_code: '+977',
  code: 'NP',
  order: 149,
  img: require('@/assets/countriesPic/np.svg')
}, {
  name: 'Netherlands',
  dial_code: '+31',
  code: 'NL',
  order: 150,
  img: require('@/assets/countriesPic/nl.svg')
}, {
  name: 'New Caledonia',
  dial_code: '+687',
  code: 'NC',
  order: 151,
  img: require('@/assets/countriesPic/nc.svg')
}, {
  name: 'New Zealand',
  dial_code: '+64',
  code: 'NZ',
  order: 152,
  img: require('@/assets/countriesPic/nz.svg')
}, {
  name: 'Nicaragua',
  dial_code: '+505',
  code: 'NI',
  order: 153,
  img: require('@/assets/countriesPic/ni.svg')
}, {
  name: 'Niger',
  dial_code: '+227',
  code: 'NE',
  order: 154,
  img: require('@/assets/countriesPic/ne.svg')
}, {
  name: 'Nigeria',
  dial_code: '+234',
  code: 'NG',
  order: 155,
  img: require('@/assets/countriesPic/ng.svg')
}, {
  name: 'Niue',
  dial_code: '+683',
  code: 'NU',
  order: 156,
  img: require('@/assets/countriesPic/nu.svg')
}, {
  name: 'Norfolk Island',
  dial_code: '+672',
  code: 'NF',
  order: 157,
  img: require('@/assets/countriesPic/nf.svg')
}, {
  name: 'Northern Mariana Islands',
  dial_code: '+1670',
  code: 'MP',
  order: 158,
  img: require('@/assets/countriesPic/mp.svg')
}, {
  name: 'Norway',
  dial_code: '+47',
  code: 'NO',
  order: 159,
  img: require('@/assets/countriesPic/no.svg')
}, {
  name: 'Oman',
  dial_code: '+968',
  code: 'OM',
  order: 160,
  img: require('@/assets/countriesPic/om.svg')
}, {
  name: 'Pakistan',
  dial_code: '+92',
  code: 'PK',
  order: 161,
  img: require('@/assets/countriesPic/pk.svg')
}, {
  name: 'Palau',
  dial_code: '+680',
  code: 'PW',
  order: 162,
  img: require('@/assets/countriesPic/pw.svg')
}, {
  name: 'Palestinian Territory, Occupied',
  dial_code: '+970',
  code: 'PS',
  order: 163,
  img: require('@/assets/countriesPic/ps.svg')
}, {
  name: 'Panama',
  dial_code: '+507',
  code: 'PA',
  order: 164,
  img: require('@/assets/countriesPic/pa.svg')
}, {
  name: 'Papua New Guinea',
  dial_code: '+675',
  code: 'PG',
  order: 165,
  img: require('@/assets/countriesPic/pg.svg')
}, {
  name: 'Paraguay',
  dial_code: '+595',
  code: 'PY',
  order: 166,
  img: require('@/assets/countriesPic/py.svg')
}, {
  name: 'Peru',
  dial_code: '+51',
  code: 'PE',
  order: 167,
  img: require('@/assets/countriesPic/pe.svg')
}, {
  name: 'Philippines',
  dial_code: '+63',
  code: 'PH',
  order: 168,
  img: require('@/assets/countriesPic/ph.svg')
}, {
  name: 'Pitcairn',
  dial_code: '+872',
  code: 'PN',
  order: 169,
  img: require('@/assets/countriesPic/pn.svg')
}, {
  name: 'Poland',
  dial_code: '+48',
  code: 'PL',
  order: 170,
  img: require('@/assets/countriesPic/pl.svg')
}, {
  name: 'Portugal',
  dial_code: '+351',
  code: 'PT',
  order: 171,
  img: require('@/assets/countriesPic/pt.svg')
}, {
  name: 'Puerto Rico',
  dial_code: '+1939',
  code: 'PR',
  order: 172,
  img: require('@/assets/countriesPic/pr.svg')
}, {
  name: 'Qatar',
  dial_code: '+974',
  code: 'QA',
  order: 173,
  img: require('@/assets/countriesPic/qa.svg')
}, {
  name: 'Romania',
  dial_code: '+40',
  code: 'RO',
  order: 174,
  img: require('@/assets/countriesPic/ro.svg')
}, {
  name: 'Russia',
  dial_code: '+7',
  code: 'RU',
  order: 175,
  img: require('@/assets/countriesPic/ru.svg')
}, {
  name: 'Rwanda',
  dial_code: '+250',
  code: 'RW',
  order: 176,
  img: require('@/assets/countriesPic/rw.svg')
}, {
  name: 'Reunion',
  dial_code: '+262',
  code: 'RE',
  order: 177,
  img: require('@/assets/countriesPic/re.svg')
}, {
  name: 'Saint Barthelemy',
  dial_code: '+590',
  code: 'BL',
  order: 178,
  img: require('@/assets/countriesPic/bl.svg')
}, {
  name: 'Saint Helena, Ascension and Tristan Da Cunha',
  dial_code: '+290',
  code: 'SH',
  order: 179,
  img: require('@/assets/countriesPic/sh.svg')
}, {
  name: 'Saint Kitts and Nevis',
  dial_code: '+1869',
  code: 'KN',
  order: 180,
  img: require('@/assets/countriesPic/kn.svg')
}, {
  name: 'Saint Lucia',
  dial_code: '+1758',
  code: 'LC',
  order: 181,
  img: require('@/assets/countriesPic/lc.svg')
}, {
  name: 'Saint Martin',
  dial_code: '+590',
  code: 'MF',
  order: 182,
  img: require('@/assets/countriesPic/mf.svg')
}, {
  name: 'Saint Pierre and Miquelon',
  dial_code: '+508',
  code: 'PM',
  order: 183,
  img: require('@/assets/countriesPic/pm.svg')
}, {
  name: 'Saint Vincent and the Grenadines',
  dial_code: '+1784',
  code: 'VC',
  order: 184,
  img: require('@/assets/countriesPic/vc.svg')
}, {
  name: 'Samoa',
  dial_code: '+685',
  code: 'WS',
  order: 185,
  img: require('@/assets/countriesPic/ws.svg')
}, {
  name: 'San Marino',
  dial_code: '+378',
  code: 'SM',
  order: 186,
  img: require('@/assets/countriesPic/sm.svg')
}, {
  name: 'Sao Tome and Principe',
  dial_code: '+239',
  code: 'ST',
  order: 187,
  img: require('@/assets/countriesPic/st.svg')
}, {
  name: 'Saudi Arabia',
  dial_code: '+966',
  code: 'SA',
  order: 188,
  img: require('@/assets/countriesPic/sa.svg')
}, {
  name: 'Senegal',
  dial_code: '+221',
  code: 'SN',
  order: 189,
  img: require('@/assets/countriesPic/sn.svg')
}, {
  name: 'Serbia',
  dial_code: '+381',
  code: 'RS',
  order: 190,
  img: require('@/assets/countriesPic/rs.svg')
}, {
  name: 'Seychelles',
  dial_code: '+248',
  code: 'SC',
  order: 191,
  img: require('@/assets/countriesPic/sc.svg')
}, {
  name: 'Sierra Leone',
  dial_code: '+232',
  code: 'SL',
  order: 192,
  img: require('@/assets/countriesPic/sl.svg')
}, {
  name: 'Singapore',
  dial_code: '+65',
  code: 'SG',
  order: 193,
  img: require('@/assets/countriesPic/sg.svg')
}, {
  name: 'Slovakia',
  dial_code: '+421',
  code: 'SK',
  order: 194,
  img: require('@/assets/countriesPic/sk.svg')
}, {
  name: 'Slovenia',
  dial_code: '+386',
  code: 'SI',
  order: 195,
  img: require('@/assets/countriesPic/si.svg')
}, {
  name: 'Solomon Islands',
  dial_code: '+677',
  code: 'SB',
  order: 196,
  img: require('@/assets/countriesPic/sb.svg')
}, {
  name: 'Somalia',
  dial_code: '+252',
  code: 'SO',
  order: 197,
  img: require('@/assets/countriesPic/so.svg')
}, {
  name: 'South Africa',
  dial_code: '+27',
  code: 'ZA',
  order: 198,
  img: require('@/assets/countriesPic/za.svg')
}, {
  name: 'South Georgia and the South Sandwich Islands',
  dial_code: '+500',
  code: 'GS',
  order: 199,
  img: require('@/assets/countriesPic/gs.svg')
}, {
  name: 'Spain',
  dial_code: '+34',
  code: 'ES',
  order: 200,
  img: require('@/assets/countriesPic/es.svg')
}, {
  name: 'Sri Lanka',
  dial_code: '+94',
  code: 'LK',
  order: 201,
  img: require('@/assets/countriesPic/lk.svg')
}, {
  name: 'Sudan',
  dial_code: '+249',
  code: 'SD',
  order: 202,
  img: require('@/assets/countriesPic/sd.svg')
}, {
  name: 'Suri\'name\'',
  dial_code: '+597',
  code: 'SR',
  order: 203,
  img: require('@/assets/countriesPic/sr.svg')
}, {
  name: 'Svalbard and Jan Mayen',
  dial_code: '+47',
  code: 'SJ',
  order: 204,
  img: require('@/assets/countriesPic/sj.svg')
}, {
  name: 'Swaziland',
  dial_code: '+268',
  code: 'SZ',
  order: 205,
  img: require('@/assets/countriesPic/sz.svg')
}, {
  name: 'Sweden',
  dial_code: '+46',
  code: 'SE',
  order: 206,
  img: require('@/assets/countriesPic/se.svg')
}, {
  name: 'Switzerland',
  dial_code: '+41',
  code: 'CH',
  order: 207,
  img: require('@/assets/countriesPic/ch.svg')
}, {
  name: 'Syrian Arab Republic',
  dial_code: '+963',
  code: 'SY',
  order: 208,
  img: require('@/assets/countriesPic/sy.svg')
}, {
  name: 'Taiwan',
  dial_code: '+886',
  code: 'TW',
  order: 209,
  img: require('@/assets/countriesPic/tw.svg')
}, {
  name: 'Tajikistan',
  dial_code: '+992',
  code: 'TJ',
  order: 210,
  img: require('@/assets/countriesPic/tj.svg')
}, {
  name: 'Tanzania, United Republic of Tanzania',
  dial_code: '+255',
  code: 'TZ',
  order: 211,
  img: require('@/assets/countriesPic/tz.svg')
}, {
  name: 'Thailand',
  dial_code: '+66',
  code: 'TH',
  order: 212,
  img: require('@/assets/countriesPic/th.svg')
}, {
  name: 'Timor-Leste',
  dial_code: '+670',
  code: 'TL',
  order: 213,
  img: require('@/assets/countriesPic/tl.svg')
}, {
  name: 'Togo',
  dial_code: '+228',
  code: 'TG',
  order: 214,
  img: require('@/assets/countriesPic/tg.svg')
}, {
  name: 'Tokelau',
  dial_code: '+690',
  code: 'TK',
  order: 215,
  img: require('@/assets/countriesPic/tk.svg')
}, {
  name: 'Tonga',
  dial_code: '+676',
  code: 'TO',
  order: 216,
  img: require('@/assets/countriesPic/to.svg')
}, {
  name: 'Trinidad and Tobago',
  dial_code: '+1868',
  code: 'TT',
  order: 217,
  img: require('@/assets/countriesPic/tt.svg')
}, {
  name: 'Tunisia',
  dial_code: '+216',
  code: 'TN',
  order: 218,
  img: require('@/assets/countriesPic/tn.svg')
}, {
  name: 'Turkey',
  dial_code: '+90',
  code: 'TR',
  order: 219,
  img: require('@/assets/countriesPic/tr.svg')
}, {
  name: 'Turkmenistan',
  dial_code: '+993',
  code: 'TM',
  order: 220,
  img: require('@/assets/countriesPic/tm.svg')
}, {
  name: 'Turks and Caicos Islands',
  dial_code: '+1649',
  code: 'TC',
  order: 221,
  img: require('@/assets/countriesPic/tc.svg')
}, {
  name: 'Tuvalu',
  dial_code: '+688',
  code: 'TV',
  order: 222,
  img: require('@/assets/countriesPic/tv.svg')
}, {
  name: 'Uganda',
  dial_code: '+256',
  code: 'UG',
  order: 223,
  img: require('@/assets/countriesPic/ug.svg')
}, {
  name: 'Ukraine',
  dial_code: '+380',
  code: 'UA',
  order: 224,
  img: require('@/assets/countriesPic/ua.svg')
}, {
  name: 'United Arab Emirates',
  dial_code: '+971',
  code: 'AE',
  order: 225,
  img: require('@/assets/countriesPic/ae.svg')
}, {
  name: 'United Kingdom',
  dial_code: '+44',
  code: 'GB',
  order: 226,
  img: require('@/assets/countriesPic/gb.svg')
}, {
  name: 'United States',
  dial_code: '+1',
  code: 'US',
  order: 227,
  img: require('@/assets/countriesPic/us.svg')
}, {
  name: 'Uruguay',
  dial_code: '+598',
  code: 'UY',
  order: 228,
  img: require('@/assets/countriesPic/uy.svg')
}, {
  name: 'Uzbekistan',
  dial_code: '+998',
  code: 'UZ',
  order: 229,
  img: require('@/assets/countriesPic/uz.svg')
}, {
  name: 'Vanuatu',
  dial_code: '+678',
  code: 'VU',
  order: 230,
  img: require('@/assets/countriesPic/vu.svg')
}, {
  name: 'Venezuela, Bolivarian Republic of Venezuela',
  dial_code: '+58',
  code: 'VE',
  order: 231,
  img: require('@/assets/countriesPic/ve.svg')
}, {
  name: 'Vietnam',
  dial_code: '+84',
  code: 'VN',
  order: 232,
  img: require('@/assets/countriesPic/vn.svg')
}, {
  name: 'Virgin Islands, British',
  dial_code: '+1284',
  code: 'VG',
  order: 233,
  img: require('@/assets/countriesPic/vg.svg')
}, {
  name: 'Virgin Islands, U.S.',
  dial_code: '+1340',
  code: 'VI',
  order: 234,
  img: require('@/assets/countriesPic/vi.svg')
}, {
  name: 'Wallis and Futuna',
  dial_code: '+681',
  code: 'WF',
  order: 235,
  img: require('@/assets/countriesPic/wf.svg')
}, {
  name: 'Yemen',
  dial_code: '+967',
  code: 'YE',
  order: 236,
  img: require('@/assets/countriesPic/ye.svg')
}, {
  name: 'Zambia',
  dial_code: '+260',
  code: 'ZM',
  order: 237,
  img: require('@/assets/countriesPic/zm.svg')
}, {
  name: 'Zimbabwe',
  dial_code: '+263',
  code: 'ZW',
  order: 238,
  img: require('@/assets/countriesPic/zw.svg')
}]

export default countriesList